import { WebSocketMessageTypeIncoming } from '../../../Enums/WebSocketMessageTypeIncoming';

export class WsEspStatus {
  public Type!: WebSocketMessageTypeIncoming;
  public ModuleId!: string;
  public CurrentIpAddress!: string;
  public SignalStrength!: string;
  public LastOnline: Date = new Date();

  constructor() {
    this.Type = WebSocketMessageTypeIncoming.WsEspStatus;
  }
}
